import { BrowserRouter, Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { ProvedorSessao, useSessao } from "./estado/sessao";
import { Login } from "./paginas/Login";
import { Cadastro } from "./paginas/Cadastro";
import { VerificarEmail } from "./paginas/VerificarEmail";
import { Dashboard } from "./paginas/Dashboard";
import { Lembretes } from "./paginas/Lembretes";

function Layout({ children }: { children: ReactNode }) {
  const { usuario, sair } = useSessao();
  const { pathname } = useLocation();

  return (
    <div className="app">
      <header className="barra-topo">
        <Link to="/" className="marca-topo">
          Lembr<span>Ai</span>
        </Link>
        <div className="barra-topo-direita">
          <span className="familia">{usuario?.familiaNome}</span>
          <button className="botao botao-texto" onClick={() => void sair()}>
            Sair
          </button>
        </div>
      </header>

      <nav className="abas">
        <Link className={pathname === "/" ? "aba ativa" : "aba"} to="/">
          Painel
        </Link>
        <Link className={pathname.startsWith("/lembretes") ? "aba ativa" : "aba"} to="/lembretes">
          Lembretes
        </Link>
      </nav>

      <main>{children}</main>
    </div>
  );
}

/** Segura a renderização até a sessão ser verificada, evitando o "flash" da tela de login. */
function Protegida({ children }: { children: ReactNode }) {
  const { usuario, carregando } = useSessao();
  if (carregando) return <div className="carregando-tela">Carregando…</div>;
  if (!usuario) return <Navigate to="/entrar" replace />;
  return <Layout>{children}</Layout>;
}

/** Páginas públicas (login/cadastro): quem já está logado é mandado direto pro painel. */
function Publica({ children }: { children: ReactNode }) {
  const { usuario, carregando } = useSessao();
  if (carregando) return <div className="carregando-tela">Carregando…</div>;
  if (usuario) return <Navigate to="/" replace />;
  return <>{children}</>;
}

export function App() {
  return (
    <ProvedorSessao>
      <BrowserRouter>
        <Routes>
          <Route
            path="/entrar"
            element={
              <Publica>
                <Login />
              </Publica>
            }
          />
          <Route
            path="/cadastro"
            element={
              <Publica>
                <Cadastro />
              </Publica>
            }
          />
          {/* Não usa <Publica>: precisa funcionar mesmo se o link chegar a alguém já logado
              (ex.: abriu em outra aba) — verificar o token é uma ação válida independente disso. */}
          <Route path="/verificar-email" element={<VerificarEmail />} />
          <Route
            path="/"
            element={
              <Protegida>
                <Dashboard />
              </Protegida>
            }
          />
          <Route
            path="/lembretes"
            element={
              <Protegida>
                <Lembretes />
              </Protegida>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ProvedorSessao>
  );
}
